import PropTypes from "prop-types"
import styles from "../HowToWork.module.scss"

export const ZIC_OILS = [
    "ZIC TOP",
    "ZIC X7",
    "ZIC X9000",
    "ZIC ZERO",
    "ZIC X8",
    "ZIC X8000",
    "ZIC ULTRA",
    "ZIC X9",
    "ZIC X7000",
]

export function OilList({ items }) {
    return (
        <ul className={styles.oilList}>
            {items.map((name, i) => (
                <li key={i} className={styles.oilItem}>
                    {name}
                </li>
            ))}
        </ul>
    )
}

OilList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.string),
}

OilList.defaultProps = {
    items: ZIC_OILS,
}
